export default __webpack_public_path__ + "static/media/store-link-sample.77965e03.png";